import * as yup from 'yup';

export default function nullableString(label) {
  return yup.string().label(label).nullable();
}
